const RANGES = [
  {
    id: 'prevMonth',
    name: 'Previous Month',
  },
  {
    id: 'thisMonth',
    name: 'This Month',
  },
  {
    id: 'nextMonth',
    name: 'Next Month',
  },
];

export default RANGES;
